interface SkeletonChartProps {
  variant?: "bar" | "horizontal-bar";
  bars?: number;
  height?: number;
  className?: string;
}

/**
 * Skeleton loader for charts
 * - bar: Vertical bar chart (SessionsPerMonth)
 * - horizontal-bar: Horizontal bar chart (TopParcours, SuccessRate)
 */
const SkeletonChart = ({
  variant = "bar",
  bars = 6,
  height = 250,
  className = "",
}: SkeletonChartProps) => {
  if (variant === "horizontal-bar") {
    return (
      <div className={`${className}`} style={{ height }}>
        <div className="flex items-center justify-between mb-4">
          <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
          <div className="w-20 h-4 bg-gray-200 rounded animate-pulse" />
          <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
        </div>

        <div className="space-y-4">
          {Array.from({ length: bars }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-24 h-4 bg-gray-200 rounded animate-pulse flex-shrink-0" />
              <div className="flex-1 h-6 bg-gray-100 rounded overflow-hidden">
                <div
                  className="h-full bg-gray-200 rounded animate-pulse"
                  style={{ width: `${30 + Math.random() * 60}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className={`${className}`} style={{ height }}>
      <div className="flex items-center justify-between mb-4">
        <div className="flex gap-1">
          <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
          <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
        </div>
        <div className="w-32 h-4 bg-gray-200 rounded animate-pulse" />
        <div className="flex gap-1">
          <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
          <div className="w-6 h-6 bg-gray-200 rounded animate-pulse" />
        </div>
      </div>

      <div className="flex items-end justify-between gap-2 h-48 px-4">
        {Array.from({ length: bars }).map((_, i) => (
          <div key={i} className="flex-1 flex flex-col items-center gap-2">
            <div
              className="w-full bg-gray-200 rounded-t animate-pulse"
              style={{ height: `${20 + Math.random() * 70}%` }}
            />
            <div className="w-8 h-3 bg-gray-200 rounded animate-pulse" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SkeletonChart;
